export const CACHE_KEY_LIST_NOMENCLATURES_PAYMENT_TYPE = 'nomenclatures-payment-type';
export const CACHE_KEY_NOMENCLATURES_PAYMENT_TYPE = 'nomenclatures-payment-type-one';
export const ROUTE_PATH_NOMENCLATURES_PAYMENT_TYPE = '/settings/nomenclatures/payment-type';
export const TRANSLATION_PREFIX_NOMENCLATURES_PAYMENT_TYPE = 'nomenclaturesPaymentType';

